'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _checkbox = require('../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _messages = require('./messages');

var _messages2 = _interopRequireDefault(_messages);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var filterChecked = function filterChecked(a) {
  return a.checked;
};
var filterUnchecked = function filterUnchecked(a) {
  return !a.checked;
};

var Entries = function Entries(_ref) {
  var activeGroup = _ref.activeGroup,
      intl = _ref.intl,
      options = _ref.options,
      label = _ref.label,
      handleChange = _ref.handleChange,
      handleMultiChange = _ref.handleMultiChange;
  return _react2.default.createElement(
    'div',
    { className: cx('xsui-group-select__entries') },
    _react2.default.createElement(
      'div',
      { className: cx('xsui-group-select__entries__head') },
      _react2.default.createElement(
        'div',
        { className: cx('xsui-group-select__entries__head__count') },
        intl.formatMessage(_messages2.default.selectedItems, {
          count: options.filter(filterChecked).length,
          of: options.length,
          label: label
        })
      ),
      options.length > 0 && _react2.default.createElement(
        'div',
        { className: cx('xsui-group-select__entries__head__action') },
        options.filter(filterChecked).length === options.length ? _react2.default.createElement(
          'span',
          { onClick: handleMultiChange.bind(undefined, options.filter(filterChecked)) },
          intl.formatMessage(_messages2.default.unselectAll)
        ) : _react2.default.createElement(
          'span',
          { onClick: handleMultiChange.bind(undefined, options.filter(filterUnchecked)) },
          intl.formatMessage(_messages2.default.selectAll)
        )
      )
    ),
    _react2.default.createElement(
      'ul',
      { className: cx('xsui-group-select__entries__list') },
      options.map(function (option, i) {
        return _react2.default.createElement(
          'li',
          { key: activeGroup + '@@' + option.value + '@@' + i },
          _react2.default.createElement(_checkbox2.default, {
            name: 'entries.' + option.value,
            label: option.label,
            input: {
              value: option.checked,
              onChange: handleChange.bind(undefined, option)
            }
          })
        );
      })
    )
  );
};

Entries.propTypes = {
  activeGroup: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  intl: _reactIntl.intlShape,
  options: _propTypes2.default.array.isRequired,
  label: _propTypes2.default.string,
  handleChange: _propTypes2.default.func.isRequired,
  handleMultiChange: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(Entries);